import './App.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import {NavbarDefault} from "./components/NavbarDefault";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {AuthenticationProvider} from "./contexts/authenticationcontext";
import {HomePage} from "./pages/HomePage";
import {LoginPage} from "./pages/LoginPage";
import {AdminDashboardPage} from "./pages/Admin/AdminDashboardPage";
import {DefaultPageLayout} from "./pages/DefaultPageLayout";
import {Insurance} from "./pages/Insurance";
import {ArticleViewPage} from "./pages/ArticleViewPage";
import {BehaviourCodesPage} from "./pages/BehaviourCodesPage";
import {GeneralManagementPage} from "./pages/GeneralManagementPage";
import {RulePage} from "./pages/RulePage";
import {TechnicalDirectionPage} from "./pages/TechnicalDirectionPage";
import {ClubPage} from "./pages/ClubPage";
import {PicturesPage} from "./pages/PicturesPage";
import {GalleryViewPage} from "./pages/GalleryViewPage";
import {AlbumViewPage} from "./pages/AlbumViewPage";
import {ResultsPage} from "./pages/ResultsPage";
import {AdministrationPage} from "./pages/AdministrationPage";
import {CalendarPage} from "./pages/CalendarPage";
import {RegisterPage} from "./pages/RegisterPage";
import {MagazinePage} from "./pages/MagazinePage";
import "@cyntler/react-doc-viewer/dist/index.css";
import {SectorPage} from "./pages/SectorPage";
import {PasswordResetPage} from "./pages/PasswordResetPage";
import {BusyProvider} from "./contexts/busycontext";
import {TrustedPersonPage} from "./pages/TrustedPersonPage";
import {BondsdokterPage} from "./pages/BondsdokterPage";

const queryClient = new QueryClient();

function App() {
    return (
        <BusyProvider>
            <QueryClientProvider client={queryClient}>
                <AuthenticationProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route path={"/"} element={<NavbarDefault/>}>
                                <Route index element={<DefaultPageLayout><HomePage/></DefaultPageLayout>}/>
                                <Route path={"/login"} element={<LoginPage/>}/>
                                <Route path={"/register"} element={<RegisterPage/>}/>
                                <Route path={"/admindashboard"} element={<AdminDashboardPage/>}/>
                                <Route path={"/algemeenbestuur"} element={<GeneralManagementPage/>}/>
                                <Route path={"/clubs"} element={<ClubPage/>}/>
                                <Route path={"/kalender"} element={<CalendarPage/>}/>
                                <Route path={"/fotos"} element={<PicturesPage/>}/>
                                <Route path={"/technischdirectie"} element={<TechnicalDirectionPage/>}/>
                                <Route path={"/sectors"} element={<SectorPage/>}/>
                                <Route path={"/vertrouwenspersoon"} element={<TrustedPersonPage/>}/>
                                <Route path={"/bondsdokter"} element={<BondsdokterPage/>}/>
                                <Route path={"/administratie"}
                                       element={<DefaultPageLayout><AdministrationPage/></DefaultPageLayout>}/>
                                <Route path={"/reglement"}
                                       element={<DefaultPageLayout><RulePage/></DefaultPageLayout>}/>
                                <Route path={"/resultaten"}
                                       element={<DefaultPageLayout><ResultsPage/></DefaultPageLayout>}/>
                                <Route path={"/verzekeringen"}
                                       element={<DefaultPageLayout><Insurance/></DefaultPageLayout>}/>
                                <Route path={"/gedragscodes"}
                                       element={<DefaultPageLayout><BehaviourCodesPage/></DefaultPageLayout>}/>
                                <Route path={"/tijdschrift"}
                                       element={<DefaultPageLayout><MagazinePage/></DefaultPageLayout>}/>
                                <Route path={"/resetwachtwoord/:token"}
                                       element={<DefaultPageLayout><PasswordResetPage/></DefaultPageLayout>}/>
                                <Route path={"/articleview/:id"}
                                       element={<DefaultPageLayout><ArticleViewPage/></DefaultPageLayout>}/>
                                <Route path={"/fotos/gallerij/:id"}
                                       element={<DefaultPageLayout><GalleryViewPage/></DefaultPageLayout>}/>
                                <Route path={"/fotos/gallerij/album/:id"}
                                       element={<DefaultPageLayout><AlbumViewPage/></DefaultPageLayout>}/>
                            </Route>
                        </Routes>
                    </BrowserRouter>
                </AuthenticationProvider>
            </QueryClientProvider>
        </BusyProvider>

    );
}

export default App;
